import { Avatar, Button, Checkbox, Space, Spin, Tooltip } from "antd";
import { useEffect, useMemo, useState } from "react";

import { voteApi } from "../../api/vote.api";
import { VoteAnswer, VoteSummary } from "../../types/vote";
import styles from "./styles/style.module.scss";

export const VoteComponent = ({ newsId }: { newsId?: number }) => {
  const [loading, setLoading] = useState(false);
  const [voteSummary, setVoteSummary] = useState<VoteSummary>();

  useEffect(() => {
    console.log("newsId", newsId);

    if (newsId) {
      fetchData();
    }
  }, [newsId]);

  const fetchData = async () => {
    setLoading(true);
    const res = await voteApi.summary({ newsId });

    setLoading(false);

    setVoteSummary(res.data);
  };

  return (
    <Spin spinning={loading}>
      <div className={`${styles.voteContainer} ${styles.disabled}`}>
        <h2>{voteSummary?.vote?.name}</h2>

        {/* {vote.} */}
        <p className="text-blue">
          {voteSummary?.totalVotes} người đã bình chọn
        </p>
        {voteSummary?.vote?.voteAnswers.map((item) => (
          <VoteItem
            totalVotes={voteSummary.totalVotes}
            data={item}
            key={item.id}
            voteAnswer={voteSummary.voteAnswers.find(
              (vote) => vote.id == item.id
            )}
            isChecked={false}
          />
        ))}
      </div>
    </Spin>
  );
};

const VoteItem = ({
  data,
  isChecked,
  totalVotes = 0,
  voteAnswer,
}: {
  data: VoteAnswer;
  isChecked: boolean;
  voteAnswer?: VoteAnswer;
  totalVotes: number;
}) => {
  const votePercent = useMemo(() => {
    if (totalVotes && voteAnswer) {
      return (voteAnswer.totalVote / totalVotes) * 100;
    } else {
      return 0;
    }
  }, [data, voteAnswer]);

  return (
    <>
      <Tooltip title={votePercent.toFixed(2) + " %"}>
        <div
          className={`${styles.voteItem} ${isChecked && styles.active}`}
          style={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div
            style={{ width: `${votePercent || 0}%` }}
            className={styles.percent}
          ></div>

          <Space>
            <Checkbox checked={isChecked} value={data.id}></Checkbox>
            {data.name}
          </Space>

          <Avatar.Group
            maxCount={2}
            maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
          >
            {voteAnswer?.customers?.map((item) => (
              <Tooltip key={item.id} title={item.firstName} placement="top">
                <Avatar src={item.avatar}>{item.firstName[0]}</Avatar>
              </Tooltip>
            ))}
          </Avatar.Group>
        </div>
      </Tooltip>
    </>
  );
};
